import { ChevronRight } from "lucide-react";
import Link from "next/link";

interface ToolButtonProps {
  buttonText: string;
  buttonLink: string;
  inNewTab?: boolean;
}

const ToolButton = ({ buttonText, buttonLink, inNewTab = false }: ToolButtonProps) => {
  return (
    <Link
      href={buttonLink}
      target={inNewTab ? "_blank" : undefined}
      rel={inNewTab ? "noopener noreferrer" : undefined}
      className="flex items-center gap-4 rounded-full bg-[#335CFF] px-8 py-5 text-lg font-medium tracking-wide text-white duration-200 ease-in-out hover:scale-[1.01] md:text-[26px]"
    >
      {buttonText} <ChevronRight className="size-[1em]" />
    </Link>
  );
};

export default ToolButton;
